import { useEffect, useState } from 'react'
import { useGetSharedUsersDashboardMutation } from '../../Redux/Workspace/workspaceActionsSlice'
import HLServerSearchListDialog from '../../GenericComponents/hlServerSearchListDialog'
import { ShareDashboardCallbacks } from '../../GenericComponents/shareDashboardCallbacks'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'

declare const window: any
const UnicornApp = window.unicornInstance as any

const ShareDashboardComponent = ({
    dashBoardId,
    isOpen,
    onClose,
    onShareSuccess,
}: {
    dashBoardId: number
    isOpen: boolean
    onClose: () => void
    onShareSuccess: () => void
}) => {
    const [shareDashBoardElement, setDashBoardElement] = useState<any>([])
    const [getSharedUsersDashboard] = useGetSharedUsersDashboardMutation()
    useEffect(() => {
        if (isOpen) {
            showShareDashBoardDialog()
        }
    }, [isOpen])
    const showShareDashBoardDialog = async () => {
        const elementObj = await handleGetSharedUsersDashboard(dashBoardId)
        setDashBoardElement(elementObj)
    }

    const handleGetSharedUsersDashboard = async (dashBoardId: any): Promise<any> => {
        const formData = new FormData()
        formData.append('dashBoardId', dashBoardId)

        try {
            const response = await getSharedUsersDashboard(formData).unwrap()

            if (response?.statusCode === 201) {
                return response.data.map(
                    (shareUser: { FullName: string; EmailAddress: string; UserId: string }) => ({
                        DisplayText: `${shareUser.FullName} (<i>${shareUser.EmailAddress}</i>)`,
                        KeyValue: shareUser.UserId,
                    })
                )
            } else if (response?.statusCode === 'OperationNotAllowed') {
                FoundationsGenericToaster(
                    'error',
                    'Sorry, you do not have permission to complete this operation.'
                )
                return null
            } else {
                FoundationsGenericToaster('error', 'Failed to get shared users for this dashboard.')
                return null
            }
        } catch (error) {
            FoundationsGenericToaster('error', 'An error occurred while fetching shared users.')
            console.error('Error fetching shared users:', error)
            return null
        }
    }

    return (
        <>
            <HLServerSearchListDialog
                elementObj={shareDashBoardElement}
                onClose={onClose}
                isOpen={isOpen}
                callbacks={ShareDashboardCallbacks(dashBoardId, onShareSuccess)}
            ></HLServerSearchListDialog>
        </>
    )
}

export default ShareDashboardComponent
